import CustomTabs from "@/components/CustomTabs";
import { useState } from "react";
import CustomTabPanel from '@/components/CustomTabPanel';
import FleetManagementTabContent from "./components/FleetManagementTabContent";
import { options } from "./mockData";

const MeetInDetailsTabs = () => {
  const [currentTab, setCurrentTab] = useState<number>(0);
  return (
    <CustomTabs
      onChange={setCurrentTab} 
      value={currentTab} 
      type="textWithIcon"
      options={options.map(({ label, icon: Icon }) => ({
        label,
        icon: <Icon />
      }))}
    >
      <CustomTabPanel value={currentTab} index={0} sx={{ paddingTop: { xs: "24px", lg: "80px" } }}>
        <FleetManagementTabContent />
      </CustomTabPanel>
    </CustomTabs>
  );
};

export default MeetInDetailsTabs;